<template>
  <div class="income-container">
    <el-form ref="form" :model="form" :inline="true" size="small">
      <el-row>
        <el-col :span="6">
          <el-form-item label="账户名称">
            <el-input v-model="form.name" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创建日期">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商户">
            <el-select v-model="form.region" placeholder="请选择活动区域" style="width: 100%;">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="状态">
            <el-select v-model="form.region" placeholder="请选择活动区域" style="width: 100%;">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="关键字">
            <el-input v-model="form.name" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" size="small">查询</el-button>
          <el-button type="primary" size="small" plain>重置</el-button>
        </el-col>
      </el-row>
    </el-form>
    <div>
      <div class="status-container">
        <div class="status-item" :class="{ 'active': activeStatus === 'pending' }" @click="setActiveStatus('pending')">
          待审批（100）
        </div>
        <div class="status-item" :class="{ 'active': activeStatus === 'approved' }"
          @click="setActiveStatus('approved')">
          审批通过（22）
        </div>
        <div class="status-item" :class="{ 'active': activeStatus === 'unreceived' }"
          @click="setActiveStatus('unreceived')">
          未收到（5）
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%" border max-height="500">
        <el-table-column fixed prop="accountName" label="账户名称">
        </el-table-column>
        <el-table-column prop="type" label="类型">
        </el-table-column>
        <el-table-column prop="merchant" label="商户">
        </el-table-column>
        <el-table-column prop="amount" label="金额">
        </el-table-column>
        <el-table-column prop="operator" label="操作人">
        </el-table-column>
        <el-table-column prop="createDate" label="创建日期">
        </el-table-column>
        <el-table-column prop="approvalStatus" label="审批状态">
          <template slot-scope="scope">
            <span v-if="scope.row.approvalStatus === 'passed'" style="color: #67C23A;">通过</span>
            <span v-else-if="scope.row.approvalStatus === 'failed'" style="color: #F56C6C;">失败</span>
            <span v-else-if="scope.row.approvalStatus === 'pending'" style="color: #E6A23C;">待审</span>
            <span v-else-if="scope.row.approvalStatus === 'unreceived'" style="color: #909399;">未收到</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注">
        </el-table-column>
        <el-table-column prop="screenshot" label="截图">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="scope.row.screenshot">
              <i class="el-icon-picture"></i>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="scope.row.approvalStatus === 'pending'">确认收款</el-button>
            <el-button type="text" size="small">查看订单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-pagination">
        <el-pagination @current-change="currentChange" :current-page="1" :page-size="10"
          layout="total, prev, pager, next, jumper" :total="1000">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      activeStatus: 'pending',
      tableData: [
        {
          accountName: 'XXXX公司',
          type: '收入',
          merchant: 'xxx',
          amount: '1000',
          operator: '张山',
          createDate: '2023-03-31',
          approvalStatus: 'passed',
          remark: 'xxxxxx',
          screenshot: true
        },
        {
          accountName: 'YYYY公司',
          type: '收入',
          merchant: 'yyy',
          amount: '2000',
          operator: '李四',
          createDate: '2023-03-30',
          approvalStatus: 'failed',
          remark: 'yyyyyy',
          screenshot: false
        },
        {
          accountName: 'ZZZZ公司',
          type: '收入',
          merchant: 'zzz',
          amount: '3000',
          operator: '王五',
          createDate: '2023-03-29',
          approvalStatus: 'pending',
          remark: 'zzzzzz',
          screenshot: true
        },
        {
          accountName: 'AAAA公司',
          type: '收入',
          merchant: 'aaa',
          amount: '4000',
          operator: '赵六',
          createDate: '2023-03-28',
          approvalStatus: 'unreceived',
          remark: 'aaaaaa',
          screenshot: false
        }
      ]
    }
  },
  methods: {
    setActiveStatus(status) {
      this.activeStatus = status;
    },
    currentChange() { }
  }
}
</script>
<style scoped lang="scss">
.income-container {}

::v-deep .el-form--inline .el-form-item {
  display: flex;
  align-items: center;

  .el-form-item__label {
    width: 70px;
  }

  .el-form-item__content {
    width: calc(100% - 70px);
  }

}

.status-container {
  display: flex;
  margin-bottom: 16px;

  .status-item {
    padding: 4px 12px;
    margin-right: 8px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 12px;
    border: 1px solid #dcdfe6;

    &:hover {
      background-color: #ecf5ff;
      border-color: #c6e2ff;
    }

    &.active {
      background-color: #409EFF;
      color: white;
      border-color: #409EFF;
      box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
    }
  }
}
.table-pagination{
  margin-top: 15px;
  text-align: right;
}
</style>
